<template>
    <div>

        <div class="row head">
            <div class="col col-100">Tenaamstelling</div>
        </div>
        <div class="row row-first setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Voornaam</span><br/>
                {{ data.firstname }}
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Voornaam</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__subtitle">{{ data.firstname }}</span>
            </div>
        </div>
        <div class="row setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Achternaam</span><br/>
                {{ data.prefix }} {{ data.lastname }}
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Achternaam</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__subtitle">{{ data.prefix }} {{ data.lastname }}</span>
            </div>
        </div>
        <div class="row row-last setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.company.$error }">
                <span class="row__title">Bedrijfsnaam</span><br/>
                <input v-model="data.company" type="text" @input="$v.data.company.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Bedrijfsnaam</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.company.$error }">
                <input v-model="data.company" type="text" @input="$v.data.company.$touch()"/>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Contactgegevens</div>
        </div>
        <div class="row row-single setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.mobile.$error }">
                <span class="row__title">Telefoonnummer</span><br/>
                <input v-model="data.mobile" type="text" @input="$v.data.mobile.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Telefoonnummer</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.mobile.$error }">
                <input v-model="data.mobile" type="text" @input="$v.data.mobile.$touch()"/>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Adresgegevens</div>
        </div>
        <div class="row setting" v-if="$root.app.platform == 'android'">
            <div class="col col-50" v-bind:class="{ 'validation-error': $v.data.address.$error }">
                <span class="row__title">Adres</span><br/>
                <input v-model="data.address" type="text" @input="$v.data.address.$touch()"/>
            </div>
            <div class="col col-30" v-bind:class="{ 'validation-error': $v.data.number.$error }"><br/>
                <input v-model="data.number" type="text" @input="$v.data.number.$touch()"/>
            </div>
            <div class="col col-20" v-bind:class="{ 'validation-error': $v.data.numberadd.$error }"><br/>
                <input v-model="data.numberadd" type="text" @input="$v.data.numberadd.$touch()"/>
            </div>
        </div>
        <div class="row row-first setting" v-if="$root.app.platform == 'ios'">
            <div class="col col-50">
                <span class="row__title">Straat</span>
            </div>
            <div class="col col-50">
                <div class="col col-100" v-bind:class="{ 'validation-error': $v.data.address.$error }">
                    <input v-model="data.address" type="text" @input="$v.data.address.$touch()"/>
                </div>
            </div>
        </div>
        <div class="row setting" v-if="$root.app.platform == 'ios'">
            <div class="col col-50">
                <span class="row__title">Huisnummer</span>
            </div>
            <div class="col col-50">
                <div class="col col-50" v-bind:class="{ 'validation-error': $v.data.number.$error }">
                    <input v-model="data.number" type="text" @input="$v.data.number.$touch()"/>
                </div>
                <div class="col col-50" v-bind:class="{ 'validation-error': $v.data.numberadd.$error }">
                    <input v-model="data.numberadd" type="text" @input="$v.data.numberadd.$touch()"/>
                </div>
            </div>
        </div>
        <div class="row setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.zip.$error }">
                <span class="row__title">Postcode</span><br/>
                <input v-model="data.zip" type="text" @input="$v.data.zip.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Postcode</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.zip.$error }">
                <input v-model="data.zip" type="text" @input="$v.data.zip.$touch()"/>
            </div>
        </div>
        <div class="row row-last setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.city.$error }">
                <span class="row__title">Plaats</span><br/>
                <input v-model="data.city" type="text" @input="$v.data.city.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Plaats</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.city.$error }">
                <input v-model="data.city" type="text" @input="$v.data.city.$touch()"/>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Bedrijfsgegevens</div>
        </div>
        <div class="row row-first setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.coc.$error }">
                <span class="row__title">KvK nummer</span><br/>
                <input v-model="data.coc" type="text" @input="$v.data.coc.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">KvK nummer</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.coc.$error }">
                <input v-model="data.coc" type="text" @input="$v.data.coc.$touch()"/>
            </div>
        </div>
        <div class="row setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.companyemail.$error }">
                <span class="row__title">Factuur e-mail</span><br/>
                <input v-model="data.companyemail" type="text" @input="$v.data.companyemail.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Factuur e-mail</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.companyemail.$error }">
                <input v-model="data.companyemail" type="text" @input="$v.data.companyemail.$touch()"/>
            </div>
        </div>
         <div class="row setting row-last">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.voicemailEmail.$error }">
                <span class="row__title">Voicemail e-mail</span><br/>
                <input v-model="data.voicemailEmail" type="text" @input="$v.data.voicemailEmail.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Voicemail e-mail</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.voicemailEmail.$error }">
                <input v-model="data.voicemailEmail" type="text" @input="$v.data.voicemailEmail.$touch()"/>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Wachtwoord instellingen</div>
        </div>
        <div class="row setting row-single has-subitem">
            <router-link to="/password-edit">
                <div v-if="$root.app.platform == 'android'" class="col col-100">
                    <span class="row__title">Wachtwoord wijzigen</span><br/>
                </div>
                <div v-if="$root.app.platform == 'ios'" class="col col-100">
                    <span class="row__title">Wachtwoord wijzigen</span>
                </div>
            </router-link>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Betaalgegevens</div>
        </div>

        <div class="row setting row-single row-last" @click="showIban(data.iban)">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.iban.$error }">
                <span class="row__title" >Bankrekening</span><br/>
                {{ data.iban | truncate(12) }}
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Bankrekening</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.iban.$error }">
                {{ data.iban | truncate(12) }}
            </div>
        </div>
        
        <div class="row row-single setting explanation">Je kunt je een wijziging van je bankrekening doorgeven via My Dubline op onze website.</div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
          <div class="col col-100">Factuurgegevens</div>
        </div>
        <div class="row setting row-single row-last">
          <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.data.ponumber.$error }">
            <span class="row__title">PO-nummer</span><br/>
            <input v-model="data.ponumber" type="text" @input="$v.data.ponumber.$touch()"/>
          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50">
            <span class="row__title">PO-nummer</span>
          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.data.ponumber.$error }">
            <input v-model="data.ponumber" type="text" @input="$v.data.ponumber.$touch()"/>
          </div>
        </div>

<!--        <div class="row row-last setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">BIC</span><br/>
                <input v-model="data.bic" type="text" @input="$v.data.bic.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">BIC</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <input v-model="data.bic" type="text" @input="$v.data.bic.$touch()"/>
            </div>
        </div>-->

        <div class="row spacer">&nbsp;</div>

        <div class="row row-button">
            <div class="col col-100">
                <button class="button" @click="submit">Gegevens opslaan</button>
            </div>
        </div>

        <div class="row spacer" v-if="$root.app.platform == 'ios' && data.hasSubscription == false">&nbsp;</div>

        <div class="row row-button" v-if="data.hasSubscription == false" v-bind:class="{explanation: data.schedule}">
            <div v-if="!data.schedule" class="col col-100">
                <button class="button" @click="remove_account">Verwijder mijn account</button>
            </div>
            <div v-else class="col col-100">
                Je hebt aangegeven het account te willen verwijderen. Het account wordt <b>definitief verwijderd</b> op {{data.schedule.scheduleTime}}.
            </div>
        </div>

        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>

        <div v-if="requestSend" class="row row-last setting explanation notice">
            <div class="col col-100">
                Je verzoek voor een <b>export van persoonlijke data</b> is ingediend. Je ontvangt van ons direct een mail om het bestand te downloaden.
            </div>
        </div>
        <div v-else class="row row-button">
            <div class="col col-100">
                <button class="button" @click="export_data">Exporteer persoonlijke data </button>
            </div>
        </div>

        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>

    </div>
</template>

<script>

    import { required, minLength, maxLength, numeric, email, alphaNum } from 'vuelidate/lib/validators'

    export default {
    name: 'Account',
        data () {

            return {
                data: [],
                requestSend: false
            }
        },

        validations: {
            data:{
                mobile:{
                    required,
                    minLength: minLength(10),
                    maxLength: maxLength(14),
                    numeric
                },
                address:{
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(30)
                },
                number:{
                    numeric,
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(4)
                },
                numberadd:{
                    maxLength: maxLength(10)
                },
                city:{
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(30)
                },
                zip:{
                    required,
                    minLength: minLength(6),
                    maxLength: maxLength(7)
                },
                company:{
                    minLength: minLength(2),
                    maxLength: maxLength(128)
                },
                coc:{
                    numeric,
                    minLength: minLength(8),
                    maxLength: maxLength(12)
                },
                companyemail:{
                    email,
                    minLength: minLength(5),
                    maxLength: maxLength(100)
                },
                voicemailEmail:{
                    email,
                    maxLength: maxLength(100)
                },
                iban:{
                    required,
                    alphaNum,
                    minLength: minLength(10),
                    maxLength: maxLength(34)
                },
                ponumber: {
                  maxLength: maxLength(128)
                }
            }
        },

        mounted(){

            this.$api.get('/account')
            .then(response => {

                this.data = response.data;
            })
            .catch(e => {

            })
        },

        created(){


        },

        methods:{

            submit: function(){

                var _this = this;
                var root = this.$root;
                root.loading = true;
                root.app.state = 'save';

                if(!this.data.voicemailEmail)
                {
                    this.data.voicemailEmail = this.data.email;
                }

                this.$api.post('/account', this.data)
                .then(response => {

                    root.loading = false;
                    root.app.state = 'get';

                    _this.$root.ui.showDialog(
                        'Voltooid',
                        'Gegevens zijn opgeslagen.',
                        true
                    );
                })
                .catch(e => {

                    root.loading = false;
                    root.app.state = 'get';

                    _this.$root.ui.showDialog(
                        'Fout',
                        'De gegevens konden niet worden opgeslagen door een fout:<br/>'+e.response.data.message,
                        true
                    );
                })
            },

            remove_account: function(){

                var _this = this;
                var root = this.$root;

                _this.$root.ui.showDialog(
                    'Verwijderen',
                    'Je account zal aan het begin van de volgende maand verwijderd worden en zal dan niet meer toegankelijk zijn. Weet je het zeker?',
                    false,
                    {
                        0:{
                            name: 'Verwijder mijn account',
                            execute: function(){

                                root.loading = true;

                                _this.$api.get('/account/remove')
                                .then(response => {

                                    root.loading = false;
                                    _this.data.schedule = response.data.schedule;

                                    _this.$root.ui.showDialog(
                                        'Voltooid',
                                        'Je account wordt binnen een maand definitief verwijderd.',
                                        true
                                    );
                                })
                                .catch(e => {

                                    root.loading = false;

                                    _this.$root.ui.showDialog(
                                        'Fout',
                                        e.response.data.message,
                                        true
                                    );
                                })
                            }
                        },
                        1:{
                            name: 'Annuleren',
                            execute: function(){}
                        }
                    }
                );
            },

            export_data: function(){

                var root = this.$root;
                var _this = this;

                root.loading = true;

                this.$api.post('/download/prepare', {
                    service: 'account/export'
                })
                .then(response => {

                    _this.requestSend = true;
                    root.loading = false;
                })
                .catch(e => {

                    root.loading = false;

                    _this.$root.ui.showDialog(
                        'Fout',
                        'Gegevens konden niet worden opgehaald.',
                        true
                    );
                })
            },

            showIban(e){

                var _this = this;
                var root = this.$root;

                window.ui.showDialog(
                    'IBAN voor SEPA incasso',
                    e,
                    false,
                    {
                        0:{
                            name: 'Sluiten',
                            execute: function(){}
                        },
                    },
                    true
                );
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Account.vue